import { render, staticRenderFns } from "./资产招商项目详情_默认版本.vue?vue&type=template&id=6a540df8&scoped=true"
import script from "./资产招商项目详情_默认版本.vue?vue&type=script&lang=js"
export * from "./资产招商项目详情_默认版本.vue?vue&type=script&lang=js"
import style0 from "./资产招商项目详情_默认版本.vue?vue&type=style&index=0&id=6a540df8&prod&lang=css"
import style1 from "./资产招商项目详情_默认版本.vue?vue&type=style&index=1&id=6a540df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a540df8",
  null
  
)

export default component.exports